import React from 'react';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 pt-20 pb-10 border-t border-white/5" data-id="element-34" data-mp="3ggarzyv0aj71">
      <div className="max-w-7xl mx-auto px-6" data-id="element-35" data-mp="32o4d0g3lai96">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-36" data-mp="32pfgsfx1bq0a">
          <div className="md:col-span-5" data-id="element-37" data-mp="36oo5359b2vog">
            <div className="flex items-center gap-2.5 mb-6" data-id="element-38" data-mp="36nd5lhmw8a35">
              <img src="https://cdn.magicpatterns.com/uploads/nrutqAxUPjySDmYrV6bARm/munisverse.png" alt="MUNISVerse" className="w-8 h-8 rounded-full object-cover" data-id="element-39" data-mp="3ug3gromz2pcd" />
              <span className="font-display font-semibold text-lg tracking-tight text-white" data-id="element-40" data-mp="3le2katzkc7br">
                MUNISVerse
              </span>
            </div>
            <p className="text-zinc-400 max-w-sm mb-8" data-id="element-41" data-mp="29yxcxcohlklt">
              Explore properties before you visit. The premier PropTech platform
              for immersive virtual property tours in Nigeria.
            </p>

            {/* Socials */}
            <div className="flex items-center gap-3" data-id="element-42" data-mp="3lbmt1p3mp2eb">
              <a href="https://instagram.com/munis_verse" target="_blank" rel="noopener noreferrer" aria-label="MUNISVerse on Instagram" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition-all" data-id="element-43" data-mp="3gb8xv7n4lmxp">
                <Instagram size={18} data-id="element-44" data-mp="3472viclxzwm" />
              </a>
              <a href="https://www.linkedin.com/company/munisverse" target="_blank" rel="noopener noreferrer" aria-label="MUNISVerse on LinkedIn" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition-all" data-id="element-45" data-mp="33nmi62lvjkp">
                <Linkedin size={18} data-id="element-46" data-mp="mthk50s04swu" />
              </a>
            </div>
          </div>

          <div className="md:col-span-2" data-id="element-47" data-mp="tw618ehn64qf">
            <h4 className="text-white font-medium mb-6" data-id="element-48" data-mp="tt9y8bqxspv4">Services</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-49" data-mp="yupk260xv0ek">
              <li data-id="element-50" data-mp="13tkb1v927v9r">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-51" data-mp="13t0xsructv22">
                  MunisVerse Inspect
                </a>
              </li>
              <li data-id="element-52" data-mp="1ckt0ggd4zzw3">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-53" data-mp="1clckq3q9f0da">
                  MunisVerse Capture
                </a>
              </li>
              <li data-id="element-54" data-mp="1mhpa4perus28">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-55" data-mp="1riv40qk64ldc">
                  MunisVerse Gallery
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-56" data-mp="3tb17htaxycgg">
            <h4 className="text-white font-medium mb-6" data-id="element-57" data-mp="3tc2u8v1bkne0">Company</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-58" data-mp="2agokl81ye8ds">
              <li data-id="element-59" data-mp="25nvhspq1pa4c">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-60" data-mp="25ncbk69rca65">
                  About Us
                </a>
              </li>
              <li data-id="element-61" data-mp="21kpbji2xnixv">
                <a href="#partners" className="hover:text-white transition-colors" data-id="element-62" data-mp="1wnp5h7632g6r">
                  Partners
                </a>
              </li>
              <li data-id="element-63" data-mp="2pcnsoip2c8ix">
                <a href="#demo" className="hover:text-white transition-colors" data-id="element-64" data-mp="2pc4k3slaywhk">
                  Demo
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3" data-id="element-65" data-mp="2fe6xtan079rl">
            <h4 className="text-white font-medium mb-6" data-id="element-66" data-mp="2fdf11who75zq">Contact</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-67" data-mp="18ynupd9s2syb">
              <li data-id="element-68" data-mp="18zftewyo96st">
                <a href="mailto:munisversehq@gmail.com" className="flex items-start gap-3 hover:text-white transition-colors group" data-id="element-69" data-mp="18vrypuhhqeci">
                  <Mail size={16} className="mt-1 shrink-0 text-zinc-500 group-hover:text-white transition-colors" data-id="element-70" data-mp="2rtmvoav5el4i" />
                  <span className="break-all" data-id="element-71" data-mp="2iwmaed3dl35a">munisversehq@gmail.com</span>
                </a>
              </li>
              <li data-id="element-72" data-mp="2nue2b740sp9h">
                <a href="tel:+2349037059783" className="flex items-start gap-3 hover:text-white transition-colors group" data-id="element-73" data-mp="2nrrst1xkjzom">
                  <Phone size={16} className="mt-1 shrink-0 text-zinc-500 group-hover:text-white transition-colors" data-id="element-74" data-mp="3fkiuhry0ugl9" />
                  <span data-id="element-75" data-mp="36jkkmt0wjeur">09037059783</span>
                </a>
              </li>
              <li data-id="element-76" data-mp="1q5uezhu4wij0">
                <div className="flex items-start gap-3" data-id="element-77" data-mp="1q5cgeek01s7x">
                  <MapPin size={16} className="mt-1 shrink-0 text-zinc-500" data-id="element-78" data-mp="1v5gs7r9ypyrt" />
                  <span data-id="element-79" data-mp="1v3dvkoeb17e4">
                    Lagos, Abuja
                    <br data-id="element-80" data-mp="1nkwk4cmvbiii" />
                    Nigeria
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-zinc-500" data-id="element-81" data-mp="1wmdv5glf4u0c">
          <p data-id="element-82" data-mp="1roui2k0gin9z">© {new Date().getFullYear()} MUNISVerse. All rights reserved.</p>
          <p data-id="element-83" data-mp="13xglu2z6q7jq">Lagos, Abuja • Nigeria</p>
        </div>
      </div>
    </footer>;
}